/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Backdrop, Box, Checkbox, FormControlLabel, Grid, IconButton, StepIconProps, Typography } from '@mui/material'
import LogoPTT from "../../../assets/Image/logo-ptt.png";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnConfirm, BtnHome } from 'components/Common/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import {
    loadCaptchaEnginge,
    LoadCanvasTemplate,
    validateCaptcha
} from 'react-simple-captcha';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { AlertTitle, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import PersonIcon from '@mui/icons-material/Person';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { i18n } from 'i18n';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';


const i18nField = 'entities.DialogRegister.fields';



const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    }),
}));

function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
        1: <PersonIcon />,
        2: <PersonIcon />,
        3: <PersonIcon />,
        4: <PersonIcon />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const DialogRegister = (props) => {

    const { open, setOpen } = props;

    const [IsSaveProgress, setIsSaveProgress] = useState(false)
    const [OptionTitle, setOptionTitle] = useState([] as any);
    const [OptionAddress, setOptionAddress] = useState([] as any);
    const [OptionUnit, setOptionUnit] = useState([] as any);
    const [IsRequireOnwer, setIsRequireOnwer] = useState(false)
    const [openBackDrop, setOpenBackDrop] = React.useState(false);
    const [IsAddTelExtention, setIsAddTelExtention] = useState(false)

    const [IsTypePass, setIsTypePass] = useState(true)
    const [IsTypeConfirmPass, setIsTypeConfirmPass] = useState(true)
    const stepsTH = [
        'ลงทะเบียน',
        'ยืนยันตัวตนผ่านอีเมล',
        'ผู้ดูแลตรวจสอบข้อมูล',
        'เข้าใช้งานระบบ',
    ];

    const stepsEn = [
        'Register',
        'Verify via email',
        'Admin check infomation',
        'Login',
    ];


    const OptionTypeLocation = [
        { value: "E", label: currentLanguage() == "th" ? "พนักงาน" : "Emloyee" },
        { value: "U", label: currentLanguage() == "th" ? "หน่วยงาน" : "Unit" },
    ]
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sSoldTo, setSoldTo] = useState(null)
    const [sShipTo, setShipTo] = useState(null)
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any


    let objSchema = {
        oTitle: yupFormSchemas.object(i18n(`${i18nField}.sTitle`), { required: true }),
        sFirstname: yupFormSchemas.string(i18n(`${i18nField}.sFirstname`), { required: true }),
        sLastname: yupFormSchemas.string(i18n(`${i18nField}.sLastname`), { required: true }),
        oCompany: yupFormSchemas.object(i18n(`${i18nField}.sCompany`), { required: true, min: 5 }),
        oAddress: yupFormSchemas.object(i18n(`${i18nField}.sAddress`), { required: true }),
        sTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: true, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: IsAddTelExtention, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sEmail: yupFormSchemas.email(i18n(`${i18nField}.sEmail`), { required: true }),
        sTypeOwner: yupFormSchemas.string(i18n(`${i18nField}.sSupervisor`), { required: true }),
        oEmployee: yupFormSchemas.object(i18n(`${i18nField}.sPTTEmployee`), { required: !IsRequireOnwer }),
        oUnit: yupFormSchemas.object(i18n(`${i18nField}.sUnit`), { required: IsRequireOnwer }),
        sCaptchaRegister: yupFormSchemas.string(i18n(`${i18nField}.sRegis`), { required: true }),
        // sPassword: yupFormSchemas.string("Password", { required: true, max: 25, matches: RegexpPassword(), labelmatches: i18n(`${i18nField}.sMatchPassword`) }),
        sPassword: yupFormSchemas.string(i18n(`${i18nField}.sPassword`), { required: true, max: 25, matches: /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]])(?=.{13,}))/, labelmatches: i18n(`${i18nField}.sMatchPassword`) }),
        sConfirmPassword: yupFormSchemas.confirmPassword(i18n(`${i18nField}.sPassword`), { required: true, max: 25, matchefield: "sPassword", }),
    }

    const schema = yup.object().shape(objSchema);

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        if (open === true) {
            GetOptionRegister();
            loadCaptchaEnginge(6);
            Object.keys(form.getValues()).forEach((key => {
                form.setValue(key, null);
                if (key == "sTypeOwner") {
                    form.setValue(key, "");
                }
                form.clearErrors(key);
            }))
            form.setValue("sTypeOwner", "E")
        }
    }, [open])

    // useEffect(() => {
    //     GetOptionRegister();
    // }, [])


    const onCheckCaptcha = () => {
        let sCaptcha = form.getValues("sCaptchaRegister");

        if (validateCaptcha(sCaptcha) === true) {
            return true;
        } else {
            loadCaptchaEnginge(6);
            form.setValue("sCaptchaRegister", "")
            return false;
        }
    }

    const onRegister = () => {

        let chkCatpcha = onCheckCaptcha();
        if (chkCatpcha) {
            //popup save
            let param = {
                "nTitleID": form.getValues("oTitle") ? parseInt(form.getValues("oTitle").value) : null,
                "sFirstName": form.getValues("sFirstname") ?? null,
                "sLastName": form.getValues("sLastname") ?? null,
                "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
                "nAddrID": form.getValues("oAddress") ? parseInt(form.getValues("oAddress").value) : null,
                "sTel": form.getValues("sTel") ?? null,
                "sEmail": form.getValues("sEmail") ?? null,
                "sSaleRepType": form.getValues("sTypeOwner") ?? null,
                "nSaleRepCode": form.getValues("oUnit") ? parseInt(form.getValues("oUnit").value) : null,       //Value BA
                "sSaleRepEmpCode": form.getValues("oEmployee") ? form.getValues("oEmployee").value : null,
                "sPassword": form.getValues("sPassword") ?? null,
                "sInputTelExtension": form.getValues("sInputTelExtension") ?? null
            }
            let sMessage = currentLanguage() == "th" ? "คุณต้องการที่จะลงทะเบียนใช่หรือไม่ ?" : "Do you want to register ?";
            SwAlert.Confirm(AlertTitle.Confirm, sMessage, () => {
                setOpenBackDrop(true)
                AxiosPost(`User/Register`, param, (res) => {
                    setOpenBackDrop(false)
                    ResultAPI(res, null, () => {
                        if (res.statusCode === 200 && res.Message != "dup") {
                            setOpen(false)
                            setIsSaveProgress(true)
                            ClearForm();
                        }
                        else {
                            let sMessgae = res.Message ?? "Error";
                            if (res.Message == "dup") {
                                sMessgae = i18n(`${i18nField}.sEmailDup`)
                            }
                            setIsOpenSnackbar(true);
                            setsMessageSnackbar(sMessgae)
                            setsSeveritySnackbar("warning")
                        }
                    })
                }, null, null)
            })
        }
    }

    const ClearForm = () => {
        setIsRequireOnwer(false)
        Object.keys(form.getValues()).forEach((key => {
            form.setValue(key, null);
            form.clearErrors(key);
        }))
    }

    const GetOptionRegister = async () => {

        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 1, "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setOptionTitle(res.result?.data || [])
            })
        });

        await AxiosGet(`BAService/GetBAByAddressCustomer`, {}, (res) => {
            ResultAPI(res, null, () => {
                setOptionUnit(res.result?.data || [])
            })
        });
    }

    const onHandleField = async (eventValue, sField) => {
        if (sField === "Company") {
            //กรอง สถานที่
            if (eventValue && eventValue.value) {
                AxiosGet(`Company/GetCompanyAddress`, { "nCompanyID": parseInt(eventValue.value), "IsAdd": false }, (res) => {
                    ResultAPI(res, null, () => {
                        setOptionAddress(res.result?.data || [])
                    })
                });
            }
        }
    }

    // const onAddressChange = async (eventValue) => {
    //     await AxiosGet(`BAService/GetBAByAddressCustomer`, {}, (res) => {
    //         ResultAPI(res, null, () => {
    //             setOptionUnit(res.result?.data || [])
    //         })
    //     });
    // }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => { setOpen(!open) }}
                maxWidth={"md"}
                fullWidth
                aria-describedby="form-register"
            >
                <DialogTitle>
                    <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center">
                        <Grid item >
                            <img
                                alt={"PTT Logo"}
                                style={{ objectFit: "contain" }}
                                width="100px"
                                src={LogoPTT}
                            />

                        </Grid>
                        <Grid item >
                            <Typography style={{ color: "#000000", fontSize: "25px", fontWeight: "bold" }}>
                                {i18n(`${i18nField}.sVoiceofCustomer`)}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{ paddingTop: '10px',display: open ? "" : "none !important" }}>
                    <FormProvider {...form}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                            {/* Title  */}
                            <Grid item xs={12} sm={3}>
                                <AutoCompleteSelect
                                    name="oTitle"
                                    options={OptionTitle}
                                    label={i18n(`${i18nField}.sTitle`)}
                                    required={true}
                                />
                            </Grid>
                            {/* Firstname  */}
                            <Grid item xs={12} sm={5}>
                                <InputFormItem
                                    id="sFirstname"
                                    name="sFirstname"
                                    label={i18n(`${i18nField}.sFirstname`)}
                                    required={true}
                                    fullWidth
                                />
                            </Grid>
                            {/* Lastname  */}
                            <Grid item xs={12} sm={4}>
                                <InputFormItem
                                    id="sLastname"
                                    name="sLastname"
                                    label={i18n(`${i18nField}.sLastname`)}
                                    required={true}
                                    fullWidth
                                />
                            </Grid>
                            {/* Company  */}
                            <Grid item xs={12}>
                                <AsyncAutoComplete
                                    name="oCompany"
                                    sUrlAPI={"Company/SearchCompanyCustomer"}
                                    label={i18n(`${i18nField}.sCompany`)}
                                    required={true}
                                    textSearch={i18n(`${i18nField}.sCompanyHint`)}
                                    onChange={(event) => {
                                        onHandleField(event, "Company")
                                        form.setValue("oAddress", null)
                                        form.setValue("oEmployee", null)
                                    }}
                                />
                            </Grid>
                            {/* Address  */}
                            <Grid item xs={12}>
                                <AutoCompleteSelect
                                    name="oAddress"
                                    options={OptionAddress}
                                    label={i18n(`${i18nField}.sAddress`)}
                                    required={true}
                                    onChange={(event) => {
                                        form.setValue("oUnit", null)
                                        setShipTo(event.sShipTo)
                                        setSoldTo(event.sSoldTo)
                                        // onAddressChange(event)
                                    }}
                                />
                            </Grid>
                            {/* Email  */}
                            <Grid item xs={12} sm={12}>
                                <InputFormItem
                                    id="sEmail"
                                    name="sEmail"
                                    label={i18n(`${i18nField}.sEmail`)}
                                    required={true}
                                    fullWidth
                                />
                            </Grid>
                            {/* Tel  */}
                            <Grid item xs={12} sm={6}>
                                <InputFormItem
                                    id="sTel"
                                    name="sTel"
                                    label={i18n(`${i18nField}.sTel`)}
                                    required={true}
                                    fullWidth
                                    maxLength={10}
                                    onChange={(e)=>{
                                        if(e == "")
                                        {
                                            setIsAddTelExtention(false);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                            {<FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={IsAddTelExtention}
                                            disabled={(!form.getValues("sTel"))}
                                            onChange={() => {
                                                setIsAddTelExtention(!IsAddTelExtention);
                                                form.setValue("sInputTelExtension", null)
                                                form.clearErrors("sInputTelExtension")
                                            }}
                                        />
                                    }
                                    label={i18n(`${i18nField}.sTelExtension`)}
                                    labelPlacement="end"
                                />}
                            </Grid>
                            {IsAddTelExtention &&
                                <Grid item xs={6} sm={4}>
                                    <InputFormItem
                                        id="sInputTelExtension"
                                        name="sInputTelExtension"
                                        label={i18n(`${i18nField}.sTelExtension`)}
                                        required={true}
                                        fullWidth
                                        maxLength={10}
                                    />
                                </Grid>
                            }
                            {/* ผู้ดูแล  */}
                            <Grid item xs={12} sm={6} style={{ marginTop: '-10px' }}>
                                <RadioFormItem
                                    name="sTypeOwner"
                                    label={i18n(`${i18nField}.sSupervisor`)}
                                    required={true}
                                    options={OptionTypeLocation}
                                    value={form.getValues("sTypeOwner")}
                                    row={true}
                                    IsNewLine={false}
                                    onChange={(value) => {
                                        //~ boolean require
                                        setIsRequireOnwer(value === "E" ? false : true)
                                        form.setValue("oEmployee", null)
                                        form.setValue("oUnit", null)
                                    }}
                                />
                            </Grid>
                            {
                                form.getValues("sTypeOwner") === "E"
                                    ?
                                    <>
                                        {/* พนักงาน ปตท. ที่ดูแล / PTT Employee  */}
                                        <Grid item xs={12} sm={6}>
                                            {/* PIS */}
                                            {/* <AsyncAutoComplete
                                                name="oEmployee"
                                                sUrlAPI={"User/SearchEmpPIS"}
                                                label={i18n(`${i18nField}.sPTTEmployee`)}
                                                required={true}
                                            /> */}

                                            <AsyncAutoComplete
                                                name="oEmployee"
                                                sUrlAPI={"User/SearchEmpPISByCompany"}
                                                ParamUrl={{ "sSoldTo": sSoldTo, "sShipTo": sShipTo }}
                                                label={i18n(`${i18nField}.sPTTEmployee`)}
                                                required={true}
                                                textSearch={currentLanguage() == "th" ? "กรอกรหัสพนักงาน/ชื่อ/นามสกุล" : "Enter Employee code/First name/Last name "}
                                            />
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        {/* Unit  */}
                                        <Grid item xs={12} sm={6}>
                                            <AutoCompleteSelect
                                                name="oUnit"
                                                options={OptionUnit}
                                                label={i18n(`${i18nField}.sUnit`)}
                                                required={true}
                                            />
                                        </Grid>
                                    </>
                            }
                            {/* Password  */}
                            <Grid item xs={12} sm={6}>
                                <InputFormItem
                                    id="sPassword"
                                    name="sPassword"
                                    type={!IsTypePass ? "text" : "password"}
                                    label={i18n(`${i18nField}.sPassword`)}
                                    required={true}
                                    fullWidth
                                    endAdornment={
                                        <>
                                            <IconButton
                                                style={{ padding: '0px' }}
                                                onClick={(() => { setIsTypePass(!IsTypePass) })}
                                            >
                                                {IsTypePass ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                                            </IconButton>
                                        </>
                                    }
                                />
                            </Grid>
                            {/* Confirm Password  */}
                            <Grid item xs={12} sm={6}>
                                <InputFormItem
                                    id="sConfirmPassword"
                                    name="sConfirmPassword"
                                    // type="password"
                                    type={!IsTypeConfirmPass ? "text" : "password"}
                                    label={i18n(`${i18nField}.sConfirmPassword`)}
                                    required={true}
                                    fullWidth
                                    endAdornment={
                                        <>
                                            <IconButton
                                                style={{ padding: '0px' }}
                                                onClick={(() => { setIsTypeConfirmPass(!IsTypeConfirmPass) })}
                                            >
                                                {IsTypeConfirmPass ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                                            </IconButton>
                                        </>
                                    }
                                />
                            </Grid>
                            {/* captcha  */}
                            {
                                open ?
                                    <Grid item xs={12}>
                                        <Grid container direction="row" justifyContent="start" alignItems="center">
                                            <Grid item xs={12} sm={6}>
                                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                                    <Grid item xs={12}>
                                                        <div style={{ textAlign: 'center', background: 'radial-gradient(circle, rgba(255,255,255,1) 32%, rgba(130,209,242,1) 100%)', padding: '16px', borderRadius: '5px' }}>
                                                            <LoadCanvasTemplate
                                                                reloadText={currentLanguage() == "th" ? "รีเฟรช" : "Refresh"}
                                                                reloadColor="black"
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputFormItem
                                                            id="sCaptchaRegister"
                                                            name="sCaptchaRegister"
                                                            label={i18n(`${i18nField}.sRegis`)}
                                                            required={true}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : null
                            }
                        </Grid>
                    </FormProvider>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item >
                            <BtnConfirm txt={i18n("common.btnConfirm")} onClick={form.handleSubmit(() => { onRegister() })} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography style={{ paddingLeft: '1em' }}>
                                {i18n(`${i18nField}.sRegistrationProcedure`)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                <Grid item xs={10}>
                                    <Box sx={{ width: '100%' }}>
                                        <Stepper activeStep={4} alternativeLabel connector={<ColorlibConnector />}>
                                            {(currentLanguage() == "th" ? stepsTH : stepsEn).map((label) => (
                                                <Step key={label}>
                                                    <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
            <PopUpCustom
                setIsOpen={setIsSaveProgress}
                IsOpen={IsSaveProgress}
                sMaxWidth={'sm'}
                JsxDialogHeader={
                    <>
                        <Typography>{i18n(`${i18nField}.sReportResults`)}</Typography>
                    </>
                }
                JsxDialogContent={
                    <>
                        <Typography>{i18n(`${i18nField}.sRegissucce`)}</Typography>
                        <Typography>{i18n(`${i18nField}.sVerifyEmail`)}</Typography>
                    </>
                }
                JsxDialogAction={
                    <>
                        <Grid container direction="row" justifyContent="end" alignItems="center">
                            <Grid item >
                                <BtnHome
                                    txt={currentLanguage() == "th" ? "กลับสู่หน้าหลัก" : "Home page"}
                                    onClick={() => {
                                        setIsSaveProgress(false)
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
            />
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackDrop}
            >
                <div className="spinner">
                    <span className="ball-1"></span>
                    <span className="ball-2"></span>
                    <span className="ball-3"></span>
                    <span className="ball-4"></span>
                    <span className="ball-5"></span>
                    <span className="ball-6"></span>
                    <span className="ball-7"></span>
                    <span className="ball-8"></span>
                </div>
            </Backdrop>
        </>
    )
}

export default DialogRegister